import { ReactNode } from "react";

type Hider = {
  color: string;
  children: ReactNode;
};

export default function GradientHider({ color, children }: Hider) {
  const gradient = `linear-gradient(90deg, ${color} 2.7%, rgba(7, 1, 15, 0) 18.64%),linear-gradient(270deg, ${color} 2.83%, rgba(7, 1, 15, 0) 18.89%)`;
  
  return (
    <div style={{ background: gradient }}>
      {children}
    </div>
  );
}
